import useToken from "../useToken";
import {useCallback, useReducer} from "react";
import {client} from "../../api/client";

function reducer(state, action) {
    switch (action.type) {
        case 'FETCH_MAILS':
            return { ...state, loading: true }
        case 'SET_MAILS':
            return { ...state, mails: action.payload.mails, metaData: action.payload.metaData, loading: false, apiErrors: null }
        case 'SET_MAIL_CONVERSATION':
            return { ...state, mailConversation: action.payload.mailConversation, loading: false, apiErrors: null }
        case 'RESET_ERRORS':
            return { ...state, loading: false, apiErrors: null }
        case 'ADD_ERRORS':
            return { ...state, apiErrors: action.payload, loading: false }
        default:
            throw new Error('Action inconnue ' + action.type)
    }
}

export function useMails() {
    const {token} = useToken()
    const [state, dispatch] = useReducer(reducer, {
        loading: true,
        mails: null,
        mailConversation: null,
        metaData: null,
        apiErrors: null
    })

    const fetchAll = useCallback(async (params) => {
        dispatch({ type: 'FETCH_MAILS' })
        client('mails', {token, params})
            .then(result => {
                dispatch({type: 'SET_MAILS', payload: result})
            })
    }, [token])

    const fetchMailConversation = useCallback(async (mailId) => {
        dispatch({ type: 'FETCH_MAILS' })
        client(`mail-conversation/${mailId}`, {token})
            .then(result => {
                dispatch({type: 'SET_MAIL_CONVERSATION', payload: result})
            })
    }, [token])

    const resetApiErrors = () => {
        dispatch({ type: 'RESET_ERRORS' })
    }

    const load = useCallback(async() => {
        dispatch({ type: 'FETCH_MAILS' })
    }, [])

    return [state, { fetchAll, fetchMailConversation, resetApiErrors, load }]
}